const PREVIOUS_SEASON_CACHE_KEY_PREFIX = 'dgvmetrics.previousSeasonRating';

const createPreviousSeasonRatingCacheKey = (previousSeason: string, userId: string)=>
    `${PREVIOUS_SEASON_CACHE_KEY_PREFIX}.${previousSeason}.${userId}`;

export const getPreviousSeasonRatingFromCache = (previousSeason: string, userId: string) : number | null =>
    Number(localStorage.getItem(createPreviousSeasonRatingCacheKey(previousSeason, userId))) || null;

export const cachePreviousSeasonRating = (previousSeason: string, userId: string, rating: string) : void =>
    localStorage.setItem(createPreviousSeasonRatingCacheKey(previousSeason, userId), rating);
